import { HttpParams } from "@angular/common/http";
import { Component, NgZone, OnInit, TemplateRef, ChangeDetectorRef, ViewChild, ElementRef, Inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AdminService } from "src/app/services/admin.service";
import { apiUrl } from "../../../global/global";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { FormGroup,  FormBuilder, Validators } from "@angular/forms";
import *  as CONSTANT from "../../../services/constants";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../../../environments/firebase";
import swal from "sweetalert2";
import { UserDetailsService } from "src/app/services/user/user-details.service";
import  {Stripe} from "@stripe/stripe-js";
import {loadStripe} from '@stripe/stripe-js'; 
import { DOCUMENT } from "@angular/common";
declare var Stripe : any;
@Component({
  selector: "app-checkout",
  templateUrl: "./checkout.component.html",
  styleUrls: ["./checkout.component.css"]
})
export class CheckoutComponent implements OnInit {
  prodId:any;
  allData:any;
  allAddress:any=[];
  allCardData:any;
  stripeElements;
  allStates:any=[];
  modalRef?: BsModalRef;
  config = {
    backdrop: true,
    ignoreBackdropClick: false
  };
  showError:boolean=false;
  showThankyou:boolean=false;
  showErrorCard:boolean=false;
  cardform: FormGroup; 
  form: FormGroup;  
  token: any; 
  // pagination
  pagination = { limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 1, totalItems: null }
  currentPage: number | undefined;
  limitRecordList = CONSTANT.LIMIT_RECORD_LIST;
  // promo code
  discountPercentage: any = null; 
  showPromoCodeError:boolean=false;
  havePromo:boolean=false; 
  promoCode: FormGroup;
  userData;
  finalAmount:any
  taxAmount:any 
  // stipe
  showSubscribeFrom:boolean=false;
  // stripe global
  stripe=Stripe(environment.stripe.publicKey)
  // stripe = Stripe("pk_test_51MhDUDFGzVjaUNdauwkHavFTPm6JLl1AStYVKzLM8BFz93SHSNheMPRdaPFrLIVSnjBY9KyRRfRYpW4VwGUwOpzk00sRDA57Nw"); 
  // live
  // stripe = Stripe("pk_live_51MhDUDFGzVjaUNdakIyzHtFEmARx5iFsCLh51MSsNXMoaYAsTDpzcYwQldD8Igk088CjIcQKEQPK00cHEyutwMJ200RyNsFE4E");
  @ViewChild('payment-element', { static: true }) paymentView: ElementRef | undefined;
  paymentElements:any;
  baseUrl: string;

  constructor(private modalService: BsModalService,public router: Router,private route: ActivatedRoute,private api: AdminService,private formBuilder: FormBuilder,private _zone: NgZone,private toastrService: ToastrService,private userDetailsService: UserDetailsService, private cdf: ChangeDetectorRef,@Inject(DOCUMENT) private document: Document ) {
    this.baseUrl = this.document.location.origin;  
    this.cardform = this.formBuilder.group({
      amount: [""],
      name: ["", [Validators.required, Validators.minLength(2)]],
      CardNumber: ["", [Validators.required, Validators.minLength(18)]],
      CardExpired: ["", [Validators.required, Validators.minLength(4)]],
      CardCCV: ["", [Validators.required, Validators.minLength(3)]],
      isSaved: [""],
    })   
    this.form = this.formBuilder.group({
      subscriptionId : [""],
      inventoryId : [""],
      cardId : [""],
      promoCardId : [""],
      firstName : ["", [Validators.required, Validators.minLength(3)]],
      lastName : ["", [Validators.required, Validators.minLength(3)]],
      companyName: ["", Validators.compose([Validators.required])],
      countryCode: ["+1"],
      phoneNumber : ["", [Validators.required, Validators.minLength(10)]],
      address : ["", [Validators.required]], 
      state : ["", [Validators.required]], 
      city : ["", [Validators.required]], 
      zipCode : [""], 
      countryName : ["", [Validators.required]], 
    }) 
    this.promoCode = this.formBuilder.group({
      promoCode : ["", [Validators.required]], 
    })
    this.userDetailsService.getRecruiterUserData();
    this.userDetailsService.userDetailsObserver.subscribe(userData => {
      this.userData = userData;
      
    });  
   }

  ngOnInit(): void {
    this.prodId = this.route.snapshot.paramMap.get("id");
    this.getPlans();
    this.getAddress();
    this.getState();
    this.getAllCards("1");
    this.cdf.detectChanges();
  }

  getPlans(){
    let params = new HttpParams(); 
    params = params.append("id", this.prodId);
    this.api.getDetail(apiUrl._paymentPlanDetail+"/"+this.prodId,"")
    .subscribe(async (res) => {
      this.allData =res.data;
      this.finalPrice();
      this.cardform.patchValue({
        amount: this.allData?.planAmount,
      }) 
      if(this.allData.planType == 0){
        this.form.patchValue({
          subscriptionId: this.allData?.id,
        }) 
      } else{
        this.form.patchValue({
          inventoryId: this.allData?.id,
        })
      }
      this.cdf.detectChanges();
    })
   }
   getAddress(){
     this.api.getDatas(apiUrl._billingAddress)
     .subscribe(async (res) => {
       this.allAddress = res.data;
       this.form.patchValue({
         ...this.allAddress,
         countryCode:"+1"
       })
      this.finalPrice()
      this.cdf.detectChanges();
     })
   }
   
finalPrice(){
  this.api.loader(true)
  let amount:any;
  amount =this.discountPercentage == null? this.allData?.planAmount : this.allData?.planAmount - ((this.allData?.planAmount * this.discountPercentage)/100)
  this.finalAmount=amount + ( this.allData?.planAmount * this.allAddress?.EstimatedCombinedRate/100 ) 
  this.taxAmount =  this.allData?.planAmount * this.allAddress?.EstimatedCombinedRate/100;
  this.cdf.detectChanges();
  this.api.loader(false)
}
   openModal(addMore: TemplateRef<any>) { 
    this.cardform.reset()
    this.modalRef = this.modalService.show(
      addMore,
      Object.assign({},this.config, { class: "modal-md addModal centerAlign" })
    ); 
  }
  openModalDelete(template: TemplateRef<any>) { 
    this.modalRef = this.modalService.show(
      template,
      Object.assign({},this.config, { class: "modal-md addModal centerAlign" })
    ); 
  }
  closeModal(){ 
   this.modalService.hide();
  }

  // submit
  createToken() {
  
    var amountCheck = (this.cardform.value.amount > 3 || this.cardform.value.amount == 3)
    if (this.cardform.valid) {
      this.api.loader(true)
      var month = (this.cardform.value.CardExpired).split("/")[this.cardform.value.CardExpired.split("/").length - 2]
      var year = (this.cardform.value.CardExpired).split("/")[this.cardform.value.CardExpired.split("/").length - 1]
      if (month == undefined) {
        year = this.cardform.value.CardExpired.slice(this.cardform.value.CardExpired.length - 2);
        month = this.cardform.value.CardExpired.slice(0, -2)
      }
      
      var cardNumber=this.cardform.value.CardNumber.replace(/\s/g, "");
      (<any>window).Stripe.card.createToken({
        number: cardNumber,
        cvc: this.cardform.value.CardCCV, 
        exp_month: month,
        exp_year: year,
        name: this.cardform.value.name,
      }, (status: number, response: any) => {
        this._zone.run(() => {
          console.log(status, response);
          if (status === 200) {
            this.token = response.id;
            this.onCardSubmit();
          } else {
            console.log(response.error.message)
            this.api.loader(false)
          }
        }
        )
      }) 
    } else {
      this.showErrorCard = true; 
      this.api.loader(false)
    }
  }
  keyUPvalue(event) {
    const input = event.target as HTMLInputElement;
    const trimmed = input.value.replace(/\s+/g, "").slice(0, input.value.indexOf("/") == -1 ? 4 : 5);
    if (trimmed.length > 3) {
      this.cardform.value.CardMonth = (input.value = `${trimmed.slice(0, 2)}/${trimmed.slice(trimmed.indexOf("/") == -1 ? 2 : 3)}`);
    }
  }
  keyUPvalue1(event) {
    const self = this;
    let chIbn = event.target.value.split(" ").join("");
    if (chIbn.length > 0) {
      chIbn = chIbn.match(new RegExp(".{1,4}", "g")).join(" ");
    }
    this.cardform.patchValue({
      CardNumber:chIbn
    })
  }
  
  onCardSubmit(){  
    const data={
      tokenId:this.token,
      isPrimary: 1,
      isSaved:1,
      // isSaved:this.cardform.value.isSaved == true ? 1 : 0,
    }  
    this.api.showLoader=true;
    this.api.loader(true)
    this.api.postData(apiUrl._addCard,data)
      .subscribe(async (res) => {
        this.modalRef?.hide();
        this.getAllCards("2");
        this.api.loader(false)
      })
  }
  // get all cards
  getAllCards(type){
    if(type==="2"){
      this.api.showLoader=false;
      this.api.loader(false)
    }
   
    let params = new HttpParams(); 
    this.api.getData(apiUrl._getLastCard,params)
    .subscribe(async (res) => {
      this.allCardData =res.data.listing; 
      this.form.patchValue({
        cardId : this.allCardData?.id,
      })
    })
  }
  limitRecordChange(event) {
    let limit = 0;
    this.limitRecordList.map((item) => { if (item.key == event.target.value) { limit = item.value; } });
    this.currentPage = 1;
    this.pagination.limit = limit;
    this.pagination.skip = 1;
    this.pagination.totalItems = null;
    this.pagination.maxSize = CONSTANT.MAX_SIZE;
    this.getAllCards("1");
  } 
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.pagination.skip = (event.page - 1) + 1;
    this.getAllCards("1");
  }
  applyPromo(){
    if(this.promoCode.valid){
      this.getPromo(this.promoCode)
    } else{
      this.showPromoCodeError=true;
      setTimeout(() => {
        this.showPromoCodeError=false;
      }, 1000);
    }
  }
  removePromo(){
    this.promoCode.reset()
    this.discountPercentage= null;
    this.havePromo = false
    this.finalPrice()
    this.cdf.detectChanges();
  }
  //get promo 
  getPromo(promo){
    let params = new HttpParams(); 
    params = params.append("promoType", this.allData.planType);
    params = params.append("promoCode", this.promoCode.value.promoCode);
    this.api.getData(apiUrl._getPromo,params)
    .subscribe(async (res) => {
      this.discountPercentage =res.data.listing.discountPercentage
      this.promoCode.patchValue({
       promoCode:res.data.listing.code,
      })
      this.form.patchValue({
        promoCardId:res.data.listing.id,
      })
      this.havePromo = true;
      this.finalPrice()
      this.cdf.detectChanges();
    })
  }
 
  //getState 
  getState(){
    this.api.getDatas(apiUrl._stateApi)
    .subscribe(async (res) => {
      this.allStates = res.data.rows;
    })
  }
  // check if only number
  preventNumbers(event): boolean { 
    event = (event) ? event : window.event;
    var charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
  }
  // remove empty filed
  removeEmptyFiled(form){
    const formValues = form.value;
    const formKeys = Object.keys(formValues);
    if (formKeys.length) {
      for (let i = 0; i < formKeys.length; i++) {
        if (
          formValues[formKeys[i]] == null ||
          formValues[formKeys[i]] == undefined ||
          formValues[formKeys[i]] == ""
        ) {
          delete formValues[formKeys[i]];
        }
      }
    }

    return formValues
  }
  // recurringPayment 
  recurringPaymentOn(payment){ 
    let text; 
      let message; 
      let subscribePayment:any;
      if(payment == 0){
        subscribePayment=1;
        text = "<p>Are you sure you want to allow Recurring Payment?</p>";
        message = "Recurring Payments switched on succesffully.";
      } else if(payment == 1){
        subscribePayment=0;
        text = "<p>Are you sure you want to switch off recurring payments?</p>";
        message = "Recurring Payment switched off successfully.";
      }
    swal.fire({
      html: text,
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EF7E2B",
      cancelButtonColor: "#ffffff",
      confirmButtonText:"Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      width: 500
  }).then((result) => {
    if (result.value) { 
      const data={
        subscribePayment : subscribePayment
      }
      this.api.putData(apiUrl._recurringPayment,data)
      .subscribe(async (res) => {
        this.userDetailsService.getRecruiterUserData();
        this.toastrService.success("", message)
      })
    } else{
      result.dismiss === swal.DismissReason.cancel
    }
  });
  }
  recurringPaymentOff(allData,number){ 
    let text = "<p>Are you sure you want to off Recurring Payment?</p>"; 
    swal.fire({
      html: text,
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EF7E2B",
      cancelButtonColor: "#ffffff",
      confirmButtonText:"Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      width: 500
  }).then((result) => {
    if (result.value) { 
      if( allData.planType == 0){
        const data={
          subscribePayment : 0
        }
        this.api.putData(apiUrl._recurringPayment,data)
      .subscribe(async (res) => {
        this.userDetailsService.getRecruiterUserData();
      })
    } else{
      const data={
        inventoryPayment : 0
      }
      this.api.putData(apiUrl._recurringPayment,data)
      .subscribe(async (res) => {
        this.userDetailsService.getRecruiterUserData();
      })
    }
    this.toastrService.success("", "Recurring Payment off successfully!")
  }
  });
  }
  // stripe
  openModalStripe(stripe: TemplateRef<any>) { 
    this.modalRef = this.modalService.show(
      stripe,
      Object.assign({},this.config, { class: "modal-md addModal centerAlign" })
    ); 
  }
  // on submit order
  onOrderSubmit(){
    this.form.value.countryCode= "+1";   
    // if(this.form.value.cardId == null || this.form.value.cardId == ""){
    //   this.showErrorCard = true; 
    //   return
    // }
    if(this.form.valid){
      if( this.allData.planType == 0){
          this.api.postData(apiUrl._addSubcriptionPlanV1, this.removeEmptyFiled(this.form))
        .subscribe(async (res) => { 
          let clientSecret = res.data.clientSecret
          this.showSubscribeFrom=true;
          this.sendSubscriptionClientKeyToStripe(clientSecret);
          // this.showThankyou =true 
          // setTimeout(() => {
          // this.showThankyou =false 
          //   this.router.navigate(["/dashboard"]);
          // }, 3000);
          window.scroll({ 
            top: 0, 
            left: 0, 
            behavior: 'smooth' 
          });
        })
      } else{
        this.api.postData(apiUrl._addPurchasePlan, this.removeEmptyFiled(this.form))
        .subscribe(async (res) => {
          this.showThankyou =true 
          setTimeout(() => {
          this.showThankyou =false 
            this.router.navigate(["/dashboard"]);
          }, 3000);
        })
      }
    } else{
      this.showError=true;
      setTimeout(() => {
        this.showError=false;
      }, 3000);
    }
  }
  // stripe payment confirmation
  sendSubscriptionClientKeyToStripe(key){ 
    // Set your publishable key: remember to change this to your live publishable key in production
  // See your keys here: https://dashboard.stripe.com/apikeys  
    // const stripe = Stripe('pk_test_51BTUDGJAJfZb9HEBwDg86TN1KNprHjkfipXmEDMb0gSCassK5T3ZfxsAbcgKVmAIXF7oZ6ItlZZbXO6idTHE67IM007EwQ4uN3');
    let CLIENT_SECRET= key
    const options = {
      clientSecret: CLIENT_SECRET,
      // Fully customizable with appearance API.
      appearance: {/*...*/},
    };
    // Set up Stripe.js and Elements to use in checkout form, passing the client secret obtained in step 5 
    this.stripeElements = this.stripe.elements(options) 
    // Create and mount the Payment Element
    const paymentElement = this.stripeElements?.create('payment'); 
    paymentElement.mount('#payment-element');
    this.paymentElements=paymentElement.mount('#payment-element')
   
  }
  onStripeConfirmation(){
    const form = document.getElementById('payment-form');

      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        const {error} = await this.stripe.confirmPayment({
          //`Elements` instance that was used to create the Payment Element
          elements:this.stripeElements,
          confirmParams: {
            return_url: this.baseUrl +"/confirmation-screen",
          }
          
        });

        if (error) {
          // This point will only be reached if there is an immediate error when
          // confirming the payment. Show error to your customer (for example, payment
          // details incomplete)
          const messageContainer: HTMLElement | null = document.querySelector('#error-message');
          console.log(messageContainer?.textContent,'messageContainer');
          this.toastrService.error("",error.message)
          // messageContainer.textContent = error.message;
          messageContainer?.textContent
        } else {
          this.showSubscribeFrom=false;
        }
      });
  }
}
